import TableContainer from 'components/Common/TableContainer';
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Input } from 'reactstrap'
import { addPolicyFileUploadReset, addPolicyFileUploadStart, getLifeBulkPolicies, getPolicyBulkUpload, revertBulkUpload } from 'store/actions';
import moment from 'moment'
import Loader from 'common/Loader';


// BULK UPLOAD POLICY FORMATS
import NMNH from "./BulkPolicyFormats/New_NMNH_template.xlsx"
import Upload_Health from "./BulkPolicyFormats/New_Health_template.xlsx"
import Upload_Motor from "./BulkPolicyFormats/New_Motor_template.xlsx"
import life_bulk_upload from "./BulkPolicyFormats/New_Life_template.xlsx"
import Spinners from 'components/Common/Spinner';


const PolicyBulkUpload = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedFile, setSelectedFile] = useState(null)
    const [selectedBulk, setSelectedBulk] = useState(null);
    const [revertModal, setRevertModal] = useState(false);
    const [revertUploadType, setRevertUploadType] = useState("")

    const [policymodalOpen, setPolicymodalOpen] = useState(false);
    const [bulkPolicyFormat, setBulkPolicyFormat] = useState("NMNH");

    const { uploaded, uploading, bulkupload, successMsg, error, bulkPoliciesList, lifeBulkPolicyList } = useSelector(state => state.fileUploadReducer);


    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
                Cell: ({ row }) => {
                    return <>{row.index + 1}</>;
                },
            },
            {
                Header: "File Name",
                accessor: "filename",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original.filename.substring(cellProps.row.original.filename.lastIndexOf('/') + 1)}
                        </>
                    );
                },
            },
            {
                Header: "Upload Name",
                accessor: "upload_name",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original.upload_name}
                        </>
                    );
                },
            },
            {
                Header: "Total Records",
                accessor: "total_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.total_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Inserted Records",
                accessor: "inserted_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.inserted_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Updated Records",
                accessor: "updated_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.updated_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Failed Records",
                accessor: "failed_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.failed_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Duplicate Records",
                accessor: "duplicate_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.duplicate_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "status",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.status : ""}
                        </>
                    );
                },
            },

            {
                Header: "Date",
                accessor: "date",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row?.original?.date ? moment(cellProps.row.original.date).format("DD/MM/YYYY") : ""}
                        </>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "lead_status",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <Button
                            color={cellProps.row.original.status !== "Reverted" ? 'primary' : 'secondary'}
                            style={{ minWidth: "130px", fontSize: "10px" }}
                            disabled={cellProps.row.original.status == "Reverted"}
                            onClick={() => {
                                setRevertUploadType(cellProps.row.original.uploadtype)
                                setSelectedBulk(cellProps.row.original)
                                setRevertModal(true)
                            }}
                        >
                            Revert
                        </Button>
                    );
                },
            },
        ],
        []
    );

    const policytoggleModal = () => {
        setPolicymodalOpen(!policymodalOpen)
        dispatch(addPolicyFileUploadReset())
    }

    //bulk upload for policy
    const handlepolicyFileChange = e => {
        const file = e.target.files[0]
        if (file) {
            if (
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "text/csv"
            ) {
                setSelectedFile(file)
            } else {
                toast.error("Please select a valid Excel or CSV file.")
            }
        }
    }

    const downloadpolicyCSV = () => {
        const filePath =
            bulkPolicyFormat === "NMNH"
                ? NMNH
                : bulkPolicyFormat === "Health"
                    ? Upload_Health
                    : bulkPolicyFormat === "Motor"
                        ? Upload_Motor
                        : bulkPolicyFormat === "Life"
                            ? life_bulk_upload : ""
        const a = document.createElement("a")
        a.href = filePath
        a.download = `${bulkPolicyFormat}.xlsx`
        a.click()
    }

    const handlepolicyFileUpload = e => {
        const formData = new FormData()
        formData.append("upload_name", "Policy_Bulk_Upload")
        formData.append("upload_type", bulkPolicyFormat)
        formData.append("PoliciesFile", selectedFile)
        dispatch(addPolicyFileUploadStart(formData))
        //setPolicymodalOpen(false)
    }

    const HandleRevertBulk = () => {
        if (revertUploadType === 'Policy') {
            dispatch(revertBulkUpload({ "bulkupload_id": selectedBulk.id, "upload_type": "policies" }))
        } else if (revertUploadType === 'Life Policy') {
            dispatch(revertBulkUpload({ "bulkupload_id": selectedBulk.id, "upload_type": "life-policies" }))
        }
        setRevertModal(false)
    }

    useEffect(() => {
        if (successMsg && successMsg !== null) {
            toast.success(successMsg)
        }
    }, [successMsg])

    useEffect(() => {
        toast.error(error)
    }, [error])

    useEffect(() => {
        if (uploaded) {
            dispatch(getPolicyBulkUpload())
            dispatch(getLifeBulkPolicies())
        }
    }, [uploaded])

    useEffect(() => {
        dispatch(getPolicyBulkUpload())
        dispatch(getLifeBulkPolicies())
    }, [])

    return (
        <div className='page-content'>
            <div className='d-flex justify-content-between align-items-center bg-white shadow p-2 rounded-3'>
                <h2>Policy Bulk Upload</h2>


                <div>
                    <Button
                        color='primary'
                        onClick={policytoggleModal}
                    >New Bulk Upload</Button>
                    <Button
                        color='secondary'
                        className='ms-2'
                        onClick={() => navigate(-1)}>Back</Button>
                </div>
            </div>


            <div className='bg-white p-2 mt-3 rounded-3 shadow border'>
                {/* Tables DIv */}
                <h4>General Insurance Bulk Uploads</h4>

                <TableContainer
                    columns={columns}
                    Loading={uploading}
                    data={bulkPoliciesList}
                    isGlobalFilter={false}
                    isAddOptions={false}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    isShowingPageLength={true}
                    customPageSize={20}
                    tableClass="table-bordered align-middle nowrap"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                />
                {
                    uploading && <Spinners />
                }
            </div>




            <div className='bg-white p-2 mt-3 rounded-3 shadow border'>
                {/* Tables DIv */}
                <h4>Life Insurance Bulk Uploads</h4>

                <TableContainer
                    columns={columns}
                    Loading={uploading}
                    data={lifeBulkPolicyList}
                    isGlobalFilter={false}
                    isAddOptions={false}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    isShowingPageLength={true}
                    customPageSize={20}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                />
                {
                    uploading && <Spinners />
                }
            </div>



            <div>
                <Modal
                    isOpen={policymodalOpen}
                    toggle={policytoggleModal}
                >
                    <ModalHeader toggle={policytoggleModal}>
                        Bulk Policies Upload File
                    </ModalHeader>
                    <ModalBody>
                        <Input
                            className="mb-1"
                            type="select"
                            onChange={e => {
                                setBulkPolicyFormat(e.target.value)
                            }}
                        >
                            <option value={"NMNH"} defaultChecked>NMNH</option>
                            <option value={"Health"}>Health</option>
                            <option value={"Motor"}>Motor</option>
                            <option value={"Life"}>Life Insurance</option>
                        </Input>
                        <Input
                            type="file"
                            accept=".xlsx,.csv"
                            onChange={handlepolicyFileChange}
                        />
                    </ModalBody>
                    {uploading ? (
                        <Loader />
                    ) : (
                        <>
                            {bulkupload &&
                                Object.keys(bulkupload).length > 0 && (
                                    <>
                                        <h6
                                            className="mb-2"
                                            style={{ backgroundColor: "#ffeeba" }}
                                        >
                                            Uploading Status:
                                            <br />
                                            {bulkupload.message
                                                ? bulkupload.message
                                                : ""}
                                        </h6>
                                        <h6
                                            className="mb-1"
                                            style={{ backgroundColor: "#d4edda" }}
                                        >
                                            Duplicate Policies:
                                            {bulkupload.duplicatePolicyMsg &&
                                                bulkupload.duplicatePolicyMsg.length >
                                                0 ? (
                                                bulkupload.duplicatePolicyMsg.map(
                                                    (msg, index) => (
                                                        <div key={index}>
                                                            {msg
                                                                .split("")
                                                                .map((letter, index) => (
                                                                    <span
                                                                        key={index}
                                                                        style={{ color: "blue" }}
                                                                    >
                                                                        {letter}
                                                                    </span>
                                                                ))}
                                                        </div>
                                                    )
                                                )
                                            ) : (
                                                <div>No duplicate Policies</div>
                                            )}
                                        </h6>

                                        <h6
                                            className="mb-1"
                                            style={{ backgroundColor: "#f8d7da" }}
                                        >
                                            Failed Policies:
                                            {bulkupload.FailedPolicyMsg &&
                                                bulkupload.FailedPolicyMsg.length > 0 ? (
                                                bulkupload.FailedPolicyMsg.map(
                                                    (msg, index) => (
                                                        <div key={index}>
                                                            {msg
                                                                .split("")
                                                                .map((letter, index) => (
                                                                    <span
                                                                        key={index}
                                                                        style={{ color: "red" }}
                                                                    >
                                                                        {letter}
                                                                    </span>
                                                                ))}
                                                        </div>
                                                    )
                                                )
                                            ) : (
                                                <div>No Failed Policies</div>
                                            )}
                                        </h6>
                                    </>
                                )}
                        </>
                    )}

                    <ModalFooter>
                        <Button color="primary" onClick={downloadpolicyCSV}>
                            Download Policy Format({bulkPolicyFormat})
                        </Button>
                        <Button
                            color="primary"
                            onClick={handlepolicyFileUpload}
                        >
                            Upload ({bulkPolicyFormat})
                        </Button>
                        <Button
                            color="secondary"
                            onClick={policytoggleModal}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>


            {/* Revert Bulk Upload Modal */}
            <div>
                <Modal isOpen={revertModal} toggle={() => setRevertModal(false)}>
                    <ModalHeader tag={"h4"} toggle={() => setRevertModal(false)}>
                        Do you wants to revert this bulk upload ?
                    </ModalHeader>

                    <ModalBody>
                        <table className='w-100'>
                            <tr>
                                <td className='fw-bold'>File Name</td>
                                <td>: {selectedBulk && selectedBulk.filename ? selectedBulk.filename : ""}</td>
                            </tr>

                            <tr>
                                <td className='fw-bold'>Upload Name</td>
                                <td className='text-wrap'>: {selectedBulk && selectedBulk.upload_name ? selectedBulk.upload_name : ""}</td>
                            </tr>
                        </table>
                    </ModalBody>

                    <ModalFooter>
                        <div className='d-flex justify-content-between align-items-center w-100'>
                            <Button color='danger' onClick={HandleRevertBulk}>Revert Now</Button>
                            <Button color='primary' onClick={() => setRevertModal(false)}>Cancel</Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        </div>
    )
}

export default PolicyBulkUpload